import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

interface IAntennaSelectionToggleSwitchI18nProps {
	yes?: string;
	no?: string;
}

export interface IAntennaSelectionToggleSwitchProps extends IBaseElementProps {
	bodyText?: string;
	toggleSwitchStatement?: string;
	updateQuery?: (query: any) => void;
	i18n?: IAntennaSelectionToggleSwitchI18nProps;
}

const AntennaSelectionToggleSwitch: React.FC<
	IAntennaSelectionToggleSwitchProps
> = ({
	bodyText,
	toggleSwitchStatement,
	updateQuery,
	i18n,
	className,
	classNames = [],
}) => {
	const [checked, setChecked] = React.useState(false);

	const handleChange = (event) => {
		setChecked(event.target.checked);
		if (updateQuery) {
			updateQuery(event.target.checked);
		}
	};

	return (
		<div className={className || cn('toggle-switch', ...classNames)}>
			<div className="toggle-switch__container">
				{bodyText && (
					<p className="toggle-switch__body-text">{bodyText}</p>
				)}
				<div className="toggle-switch__block">
					{toggleSwitchStatement && (
						<p className="toggle-switch__statement">
							{toggleSwitchStatement}
						</p>
					)}
					<span
						className={cn(
							'toggle-switch__switch',
							checked && 'checked',
						)}
					>
						<input
							type="checkbox"
							className="toggle-switch__switch-input"
							onChange={handleChange}
							checked={checked}
						/>
						<span
							className="toggle-switch__switch-track"
							data-state={
								checked ? i18n?.yes || 'Yes' : i18n?.no || 'No'
							}
						></span>
						<span className="toggle-switch__switch-circle"></span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default AntennaSelectionToggleSwitch;
